var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _c(
        "v-card",
        {
          staticClass: "h-100 d-flex flex-column overflow-x-auto",
          attrs: { elevation: "0", outlined: "", "min-height": "350" },
        },
        [
          _c(
            "v-card-title",
            {
              staticClass:
                "py-1 white--text d-flex align-center justify-space-between",
              class: _vm.$vuetify.theme.dark ? "black" : "primary",
              staticStyle: { "flex-wrap": "nowrap" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { flex: "1 1 auto", "min-width": "0" },
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "white", medium: "" },
                    },
                    [_vm._v("assignment")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboards.reportsRequested")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "pl-0 pr-0",
                  staticStyle: { "flex-shrink": "0" },
                  attrs: { text: "", small: "", to: `/inbox` },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text text-decoration-underline font-weight-bold",
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboards.goInbox")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1",
                      attrs: { small: "", color: "white" },
                    },
                    [_vm._v("keyboard_arrow_right")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            {
              staticClass: "d-flex flex-column flex-grow-1 pa-0",
              staticStyle: { "min-height": "0" },
            },
            [
              _vm.reports && !_vm.loading
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-grow-1 flex-column flex-md-row",
                        staticStyle: { "padding-top": "0px !important" },
                      },
                      _vm._l(_vm.reports, function (report, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "d-flex flex-grow-1" },
                          [
                            _c("InboxReportItem", {
                              class: {
                                "ml-1":
                                  index != 0 && _vm.$vuetify.breakpoint.mdAndUp,
                              },
                              attrs: {
                                report: report,
                                embedded: true,
                                states: _vm.states,
                              },
                            }),
                            _vm._v(" "),
                            _vm.$vuetify.breakpoint.mdAndUp
                              ? _c("v-divider", { attrs: { vertical: "" } })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    !_vm.reports || !_vm.reports.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column pl-3 pr-3 pb-1 py-4 mb-7 text-center flex-grow-1",
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticStyle: { "font-size": "80px" },
                                attrs: { color: "primary lighten-5" },
                              },
                              [_vm._v("help_outline")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "primary--text lighten--text-2 body-1",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dashboards.placeholderReports")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                      },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "ma-0",
                          attrs: { type: "text", width: "30%" },
                        }),
                        _vm._v(" "),
                        _c("v-skeleton-loader", {
                          staticClass: "ma-0",
                          attrs: { type: "text", width: "15%" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                      },
                      _vm._l(4, function (i) {
                        return _c("v-skeleton-loader", {
                          key: i,
                          staticClass: "my-2",
                          attrs: { type: "text", width: "100%" },
                        })
                      }),
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }